import { render, staticRenderFns } from "./Bonus.vue?vue&type=template&id=6734c4c4&scoped=true"
import script from "./Bonus.vue?vue&type=script&lang=js"
export * from "./Bonus.vue?vue&type=script&lang=js"
import style0 from "./Bonus.vue?vue&type=style&index=0&id=6734c4c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734c4c4",
  null
  
)

export default component.exports